/**
 * Formato chileno: +56932865585 -> +56 9 3286 5585
 * Si no matchea +56 con 9 dígitos, retorna el original sin cambios.
 */
export function formatPhoneCL(phone) {
  if (!phone) return phone
  const m = String(phone).match(/^\+56(\d)(\d{4})(\d{4})$/)
  if (m) return `+56 ${m[1]} ${m[2]} ${m[3]}`
  return phone
}
